import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function ABanner() {
    const { useEffect, useRef } = useGlobal();
    const refV1 = useRef();

    // 鼠标滑动向上，使banner视频2/3区域（下半部分）回退到视窗中时视频重新播放
    let pageYOffset = 0;
    const onScroll = (e: any) => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        // 仅当页面从上往下回退入视窗， 且进入一半时视频重新播放
        if (pageYOffset > window?.pageYOffset && window?.pageYOffset <= layoutH / 3) {
            refV1?.current?.play();
        }
        pageYOffset = window?.pageYOffset;
    };

    useEffect(() => {
        window.addEventListener('scroll', onScroll);
    }, []);

    return (
        <div className={`A_banner ${css.A_banner}`}>
            <div className="videoBox">
                <EFVideo
                    ref={refV1}
                    sources={['/video/xboost/01_KV.webm', '/video/xboost/01_KV.mp4']}
                    className="banner_video"
                    width="100%"
                    height="100%"
                    // autoPlay={false}
                    loop={false}
                />
            </div>
        </div>
    );
}
